
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useAuthState } from '../../../../../../Helper/Context';
import { BaseUrl } from '../../../../../../Helper/BaseUrl';
import { toastErrorr, toastSuccesss } from '../../../../../../Helper/ToastMessage';
import { AstricSign } from '../../../../../../Helper/AstricSign';
import OTPModal from '../../OTPModal/OTPModal';


export default function PillerWiseBenchMarkModal(props) {

    const { item, EditIcon, Flag, IsPost, setIsPost, rowData, open, handleOnCloseClick, handleGetData } = props

    const userDetails = useAuthState();
    const { UserID, token,RoleID } = userDetails.user
    const dispatch = useDispatch();


    const [Isloading, setIsloading] = useState(false)
    const [PillerBenchmark, setPillerBenchmark] = useState(rowData?.pillerBenchMark)
    const [Remark, setRemark] = useState(rowData?.remark)


    const handlePost = () => {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", "Bearer " + token);

        const formdata = new FormData();
        formdata.append("T_ELE_Excel_CurrentRating_TempdataID", rowData?.t_elE_Excel_CurrentRating_TempdataID);
        formdata.append("M_ELEC_PillerID", rowData?.m_eleC_PillerID);
        formdata.append("PillerBenchMark", PillerBenchmark);
        formdata.append("Remark", Remark);
        formdata.append("M_UserID", UserID);

        const requestOptions = {
            method: "PATCH",
            headers: myHeaders,
            body: formdata,
            redirect: "follow"
        };
        setIsloading(true)
        fetch(`${BaseUrl}/Electrical/T_ELE_Excel_CurrentRating_Tempdata_Update`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                if (result?.code >= 200 && result?.code <= 300 && result?.data) {
                    if (result?.data[0]?.returnID > 0) {
                        handleGetData()
                        toastSuccesss(result?.message)
                        handleOnCloseClick()
                    } else {
                        toastErrorr(result?.message)
                    }
                }
                setIsloading(false)
            })
            .catch((error) => {
                setIsloading(false)
                console.error(error)
            });
    }

    const [ShowOtpModal, setShowOtpModal] = useState({
        show: false,
        data: ''
    })

    const handleShowOTP = (show, data) => {
        setShowOtpModal({
            show: show,
            data: data
        })
    }

    const handlePostAPI = () => {
        handlePost()
        setTimeout(() => {
            setShowOtpModal({
                show: false,
                data: ''
            })
        }, 500);
    }

    return (


        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="area_pop modal-dialog modal-dialog-scrollable modal-xl">
                <div className="modal-content master_border">
                    <div className="modal-header pl-4 p-1">
                        <h5 className="modal-title pt-1" id="staticBackdropLabel">
                            {Flag === "Update" ? "Update" : "Add"} Piller BenchMark
                        </h5>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row col-12 ">


                                <div className="col-12">
                                    <div className="form-group">
                                        <label for="" className=""><b>Piller No.</b><AstricSign /></label>
                                        <input
                                            disabled
                                            className='form-control'
                                            value={rowData?.pillerNo}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label for="" className=""><b>Piller BenchMark</b><AstricSign /></label>
                                        <input
                                            className='form-control'
                                            value={PillerBenchmark}
                                            onChange={(e) => setPillerBenchmark(e.target.value)}
                                        />
                                    </div>

                                    <div className="form-group">
                                        <label for="" className=""><b>Remark</b><AstricSign /></label>
                                        <textarea
                                            className='form-control'
                                            value={Remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                            maxLength={50}
                                        />
                                    </div>
                                </div>

                            </div>

                            <div className="col-12 col-lg-12">
                                <div className="btn-action d-flex justify-content-end mt-lg-3">

                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        // onClick={() => handlePost()}
                                        onClick={() =>{ RoleID == '46' ?  handleShowOTP(true, '') : handlePost()}}
                                        disabled={PillerBenchmark == '' || PillerBenchmark == null || Remark == '' || Remark == null}
                                    >
                                        {Flag === "Update" ? "Update" : "Add"}
                                    </button>

                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            {/* )} */}

            {
                ShowOtpModal?.show &&
                <OTPModal
                    ShowOtpModal={ShowOtpModal}
                    cancelbtn={() => handleShowOTP(false, '')}
                    OTP_Action="BenchMark"
                    handlePostAPI={handlePostAPI}
                />
            }


        </Popup>
    )

}